import { Card, CardBody, Flex, Text } from '@chakra-ui/react'
import { getSalesMetrics, getSalesMetricsByUserId } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { numberFormatter } from 'lib'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

export const SalesTiles = ({ userId, ...rest }) => {
  const { createToast } = useAppContext()
  const [salesMetrics, setSalesMetrics] = useState({ salesMtd: 0, salesQtd: 0, salesYtd: 0, salesT12: 0 })

  useEffect(() => {
    const load = async () => {
      try {
        const response = userId === 'All' ? await getSalesMetrics() : await getSalesMetricsByUserId(userId)
        setSalesMetrics(response)
      } catch (err) {
        createToast('error', 'Error', 'Failed to load sales metrics.')
      }
    }
    load()
  }, [])

  return (
    <Flex
      flexWrap="wrap"
      gap={4}
      {...rest}
    >
      <Card
        textAlign="center"
        h="100px"
        width="250px"
      >
        <CardBody display="flex" flexDirection="column" justifyContent="space-between">
          <Text>Sales (MTD)</Text>
          <Text fontWeight="bold" fontSize="lg">{`$ ${numberFormatter(salesMetrics.salesMtd)}`}</Text>
        </CardBody>
      </Card>
      <Card
        textAlign="center"
        h="100px"
        width="250px"
      >
        <CardBody display="flex" flexDirection="column" justifyContent="space-between">
          <Text>Sales (QTD)</Text>
          <Text fontWeight="bold" fontSize="lg">{`$ ${numberFormatter(salesMetrics.salesQtd)}`}</Text>
        </CardBody>
      </Card>
      <Card
        textAlign="center"
        h="100px"
        width="250px"
      >
        <CardBody display="flex" flexDirection="column" justifyContent="space-between">
          <Text>Sales (YTD)</Text>
          <Text fontWeight="bold" fontSize="lg">{`$ ${numberFormatter(salesMetrics.salesYtd)}`}</Text>
        </CardBody>
      </Card>
      {userId !== 'All' && (
        <Card
          textAlign="center"
          h="100px"
          width="250px"
        >
          <CardBody display="flex" flexDirection="column" justifyContent="space-between">
            <Text>Sales (T12)</Text>
            <Text fontWeight="bold" fontSize="lg">{`$ ${numberFormatter(salesMetrics.salesT12)}`}</Text>
          </CardBody>
        </Card>
      )}
    </Flex>
  )
}

SalesTiles.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}
